import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'
import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import en from './store/locale/en-us.json'
import zh from './store/locale/zh-cn.json'
import hk from './store/locale/zh-hk.json'
let hasLunage = localStorage.getItem('i18nextLng');
if (!hasLunage) {
  localStorage.setItem('i18nextLng', 'zh-HK')
} 
// else {
//   switch (hasLunage) {
//     case "en-US":
//       localStorage.setItem('i18nextLng', 'en-US')
//       break;
//     case "zh-CN":
//       localStorage.setItem('i18nextLng', 'zh-CN')
//       break;
//     case "zh-HK":
//     default:
//       localStorage.setItem('i18nextLng', 'zh-HK')
//       break;
//   }
// }
i18next.use(XHR).use(LanguageDetector).use(initReactI18next).init({
  resources: {
    "en-US": {
      translation: en,
    },
    "zh-CN": {
      translation: zh,
    },
    "zh-HK": {
      translation: hk
    },
  },
  fallbackLng: 'zh-HK',
  interpolation: {
    escapeValue: false,
  },
  //lng: 'zh-hk'
})

export default i18next
